import React, { lazy } from "react";
import { useParams, Navigate } from "react-router-dom";
import NotFound from './common/NotFound';
import Page from './pages/Page';
import countries from './config/comboList';
import { config as AppConfig } from './config/appconfig';

// const StateMapPage = lazy(() => import('./pages/MapPage'));
const CountryMapPage = lazy(() => import('./pages/CountryMapPage'));

// export const MapDefault = () => {
//   return <Page fullSize={true}><StateMapPage stateName="india" /></Page>;
// }
// export const ValidateState = () => {
//   const { stateName } = useParams();
//   console.log('ValidateState:', stateName);
//   let inputstate = stateName.toLowerCase().replace(/\s+/g, '');
//   let statearr = states.filter((item) => { return item.state.toLowerCase().replace(/\s+/g, '') === inputstate }); //Comparing (After removal of whitespaces and lowering the case)
//   let validstate = (statearr.length > 0);
//   console.log('--Validation-- Filtered Array:', statearr, 'InputVal:', inputstate);

//   if (!validstate) {
//     //  return <NotFound /> --Throw Error Page
//     return <Navigate replace to='/afs/state' /> // -- redirect to /state
//   }
//   let statename = statearr[0].state;
//   return <Page fullSize={true}> <StateMapPage stateName={statename} /> </Page>;//Passing name as per stored stateList.state
// }

export const ValidateCountry = () => {
  const { countryName } = useParams();
  console.log('ValidateCountry:', countryName);
  let input = countryName.toLowerCase().replace(/\s+/g, '');
  let arr = countries.filter((item) => { return item.state.toLowerCase().replace(/\s+/g, '') === input });
  let valid = (arr.length > 0);
  // console.log('--Validation-- Filtered Array:', statearr, 'Val:', inputstate);

  if (!valid) {
    //  return <NotFound /> --Throw Error Page
    return <Navigate replace to={AppConfig.context.defaultPath} /> // -- redirect to /state
  }
  // let statename = statearr[0].state;
  return <Page fullSize={true}> <CountryMapPage countryName={countryName.toUpperCase()} /> </Page>;
}
export const CountryMapDefault = () => {
  return <Page fullSize={true}><CountryMapPage countryName={AppConfig.combobox.default} /></Page>; // Need to be cap otherwise MapHandler can't filter GJOSN by lowercase afghanistan
}
export const CountryMap = (props) => {
  console.log('[App] props:',props);
  return <Page fullSize={true}><CountryMapPage countryName={props.country.toUpperCase()} /></Page>; // Need to be cap otherwise MapHandler can't filter GJOSN by lowercase afghanistan
}

export const ValidateWidget = () => {
  const { pattern } = useParams();
  let input = pattern.toLowerCase().replace(/\s+/g, '');
  let arr = AppConfig.applications.filter((item) => { return item.pattern.toLowerCase().replace(/\s+/g, '') === input });
  let valid = (arr.length > 0);

  if (!valid) {
    return <Navigate replace to={AppConfig.context.defaultPath} /> // -- redirect to /state
  }
  return <Page fullSize={true}> <CountryMapPage pattern={pattern} countryName={AppConfig.combobox.default}/> </Page>;
}




